enum SharePageStatusType {
    Current = 'current',
    Past = 'past',
    Upcoming = 'upcoming',
}

export default SharePageStatusType;
